/** @format */

import {useRef} from 'react';

import {Brush, CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis} from 'recharts';

import {Box} from '@mui/material';

import {CommonChartData} from '../../model/charts';
import {BrushRoot as Root} from './style';
import {BrushStartEndIndex} from '../../model/common';

type Props = {
  chart?: CommonChartData[];
  syncId?: string;
  top: string;
};

const CustomBrush = ({chart, syncId, top}: Props) => {
  // Brush из recharts не поддерживает useState
  const brushIndex = useRef<BrushStartEndIndex>({
    startIndex: undefined,
    endIndex: undefined,
  });

  const handleZoom = (newIndex: BrushStartEndIndex) => {
    const {startIndex, endIndex} = newIndex;
    if (typeof startIndex !== 'number' || typeof endIndex !== 'number') {
      brushIndex.current = newIndex;
      return;
    }

    if (brushIndex.current.startIndex !== startIndex || brushIndex.current.endIndex !== endIndex) {
      const event = new CustomEvent<Required<BrushStartEndIndex>>('multiline-chart:update-labels', {
        detail: {startIndex, endIndex},
      });
      window.dispatchEvent(event);
    }

    brushIndex.current = newIndex;
  };

  return (
    <Root top={top}>
      <ResponsiveContainer>
        <LineChart data={chart} dataKey='dummy' syncId={syncId}>
          <XAxis
            orientation='top'
            axisLine={false}
            tickLine={false}
            tick={props => <Box {...props} />}
            interval='preserveStartEnd'
            height={0}
          />
          <CartesianGrid horizontal={false} stroke='#48494d' />
        </LineChart>
      </ResponsiveContainer>

      <ResponsiveContainer>
        <LineChart data={chart} dataKey='dummy' syncId={syncId}>
          <Line animationDuration={0} dot={false} />
          <Brush fill='none' dataKey='dummy' travellerWidth={10} onChange={handleZoom} />
        </LineChart>
      </ResponsiveContainer>
    </Root>
  );
};

export default CustomBrush;
